module.exports = __webpack_public_path__ + "img/blogItem.31399420.png";